import { Component, Inject, OnInit } from '@angular/core';
import { DialogRef } from '../../dialog/dialog-ref';
import { DATA, DIALOG } from '../../dialog/dialog.service';

export const TITLE_RECURRING_SINGULAR = $localize`Change of recurring assignment`;
export const TITLE_RECURRING_PLURAL = $localize`Change of recurring assignments`;

export interface Data {
  assignmentCount: number
}

@Component({
  selector: 'app-edit-recurring-assignment-dialog',
  templateUrl: './edit-recurring-assignment-dialog.component.html',
  styleUrls: ['./edit-recurring-assignment-dialog.component.scss']
})
export class EditRecurringAssignmentDialogComponent implements OnInit {

  assignmentCount = 1;

  constructor(@Inject(DIALOG) private dialog: DialogRef, @Inject(DATA) data: Data) {
    this.assignmentCount = data.assignmentCount ?? 1;
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dialog.close();
  }

  ok(result: string) {
    this.dialog.close(result);
  }

}
